import React from 'react';
import { Link } from 'react-router-dom';
import type { LogoProps } from '../Header.types';
import { cn } from '@/utils/className'; // adjust the path based on where `cn` is defined

const Logo: React.FC<LogoProps> = ({ src, alt, to = '/', className }) => {
    return (
        <Link to={to} className={cn('flex items-center', className)}>
            <img src={src} alt={alt} className="me-2" />
        </Link>
    );
};

export default Logo;
